import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Button,
  Label,
  makeStyles,
  tokens,
  useToastController,
  useId,
  Toaster,
} from "@fluentui/react-components";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import {
  getAssetDetailById,
  getAssetPaymentDetailById,
  getAssetPaymentsListItems,
} from "../../../../redux/Case/assetSlice";
import { getCaseCategoryByCaseType } from "../../../../utils";
import CaseNavList from "../CaseNavList";
import CaseForm from "../CaseForm";
import CaseList from "../CaseList";
import ContentLoader from "../../../../components/Loader/ContentLoader";
import ModalDialog from "../../../../components/ModalDialog";
import CaseDetailDrawer from "../CaseDetailDrawer";
import { FormLoader } from "../../../../components/Loader/FormLoader";
import { useToastMessage } from "../../../../components/ToastMessage/ToastMessage";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";

const useStyles = makeStyles({});

function AssetPayments({ tab }: { tab: string }) {
  const navigate = useNavigate();
  const styles = useStyles();
  const { showToast, toasterId } = useToastMessage();
  const { clientId, action, caseId, subItemId } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [currentRecord, setCurrentRecord] = useState(1);

  const formSettingsObj = useSelector((state: RootState) => state.formSettings);
  const assets = useSelector((state: RootState) => state.assets);
  const dialogModalOptions = useSelector((state: RootState) => state.dialog);

  const [caseType, setCaseType] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);
  const handleDetailPopup = (action: boolean) => {
    setIsOpen(action);
  };
  useEffect(() => {
    if (caseId && clientId) {
      dispatch(getAssetDetailById({ id: caseId, customerId: clientId }));
      dispatch(getAssetPaymentsListItems({ id: caseId, customerId: clientId }));
    }
  }, [caseId, clientId, dispatch]);

  useEffect(() => {
    if (assets?.activeItem?.case_type) {
      setCaseType(getCaseCategoryByCaseType(assets.activeItem.case_type));
    }
  }, [assets?.activeItem]);

  const paymentId =
    subItemId || assets?.payments?.listItems[0]?.payment?.payment_id;

  useEffect(() => {
    if (!caseId || !paymentId) return;
    if (action === "view") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/view`
      );
    } else if (action === "add") {
      navigate(`/clients/${clientId}/assets/${caseId}/${tab || "payment"}/add`);
    } else if (action === "edit") {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/edit`
      );
    } else {
      navigate(
        `/clients/${clientId}/assets/${caseId}/payments/${paymentId}/${
          tab || "payment"
        }/view`
      );
    }
  }, [
    action,
    clientId,
    assets.payments.listItems,
    caseId,
    paymentId,
    tab,
    navigate,
  ]);

  useEffect(() => {
    if (subItemId) {
      dispatch(getAssetPaymentDetailById(subItemId));
    }
  }, [subItemId, dispatch, assets.payments.listItems]);

  return (
    <div>
      <Toaster toasterId={toasterId} position="top-end" timeout={5000} />
      <CaseNavList
        subItem="payments"
        section="assets"
        tab={tab}
        caseType={caseType}
        caseDetail={assets?.payments.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <div className="case_container_flex">
        {assets?.activeItemloading ? (
          <FormLoader />
        ) : (
          <CaseForm
            mode={action || ""}
            section="assets"
            caseType={caseType}
            caseDetail={assets?.payments.activeItem}
            caseItemList={assets?.payments.listItems}
            tab={tab}
            subItem="payments"
            paymentValue={assets?.payments.totalPayment}
            notify={showToast}
            currentRecord={currentRecord}
            setCurrentRecord={setCurrentRecord}
          />
        )}

        <div>
          {assets?.payments.loading ? (
            <ContentLoader />
          ) : (
            <>
              {assets?.payments.listItems.length > 0 && (
                <CaseList
                  module="payments"
                  data={assets?.payments.listItems}
                  activeItem={assets?.payments.activeItem}
                  section="assets"
                  activeTab={tab}
                  currentRecord={currentRecord}
                  setCurrentRecord={setCurrentRecord}
                />
              )}
              {!action && assets?.payments.listItems.length === 0 && (
                <NoDataFound />
              )}
            </>
          )}
        </div>
      </div>
      <CaseDetailDrawer
        isOpen={isOpen}
        caseDetail={assets?.activeItem}
        handleDetailPopup={handleDetailPopup}
      />
      <ModalDialog options={dialogModalOptions} />
    </div>
  );
}

export default AssetPayments;
